import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button, Input, Segment, Table, Label, Icon } from 'semantic-ui-react';
import { Link } from 'react-router';
import axios from 'axios';
import { TiktokIcon } from '../../components/dyzio-icons';

import { updateProfileSocialDetails } from './utils';
import EditButton from './edit-button';
import Tooltip from '../../components/tooltip';
import NetworkHandleInput from '../../components/network-handle-input';

const externalIconStyle = {
  color: '#20c49e',
};

class ProfileSocialDetails extends Component {
  static propTypes = {
    influencer: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      editing: false,
      facebook: props.influencer.facebook,
      facebookCount: props.influencer.facebookCount,
      facebookLoading: false,
      facebookError: false,
      instagramId: props.influencer.instagramId,
      instagram: props.influencer.instagram,
      instagramCount: props.influencer.instagramCount,
      instagramLoading: false,
      instagramError: false,
      twitter: props.influencer.twitter,
      twitterCount: props.influencer.twitterCount,
      twitterLoading: false,
      twitterError: false,
      tiktokCount: props.influencer.tiktokCount,
      tiktokError: props.influencer.tiktokError,
      youtube: props.influencer.youtube,
      youtubeCount: props.influencer.youtubeCount,
      youtubeChannelTitle: props.influencer.youtubeChannelTitle,
      youtubeLoading: false,
      youtubeError: false,
      otherChannels: props.influencer.otherChannels,
      twitch: props.influencer.twitch,
      tiktok: props.influencer.tiktok,
      web: props.influencer.web,
      snapchat: props.influencer.snapchat,
      linkedin: props.influencer.linkedin,
      pinterest: props.influencer.pinterest,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.influencer !== this.props.influencer) {
      this.setState({
        facebook: (nextProps.influencer.facebook || ''),
        facebookCount: (nextProps.influencer.facebookCount || 0),
        instagram: (nextProps.influencer.instagram || ''),
        instagramCount: (nextProps.influencer.instagramCount || 0),
        instagramId: (nextProps.influencer.instagramId || ''),
        twitter: (nextProps.influencer.twitter || ''),
        twitterCount: (nextProps.influencer.twitterCount || 0),
        youtube: (nextProps.influencer.youtube || ''),
        youtubeCount: (nextProps.influencer.youtubeCount || 0),
        youtubeChannelTitle: (nextProps.influencer.youtubeChannelTitle || ''),
        otherChannels: nextProps.influencer.otherChannels,
        twitch: (nextProps.influencer.twitch || ''),
        tiktok: (nextProps.influencer.tiktok || ''),
        web: (nextProps.influencer.web || ''),
        snapchat: (nextProps.influencer.snapchat || ''),
        linkedin: (nextProps.influencer.linkedin || ''),
        pinterest: (nextProps.influencer.pinterest || ''),
      });
    }
  }

  getChannelData = (channel, handle) => {
    const fetchableChannels = ['youtube', 'instagram', 'twitter', 'facebook', 'tiktok'];
    if (!_.includes(fetchableChannels, channel)) {
      return;
    }
    const count = `${channel}Count`;
    const loading = `${channel}Loading`;
    const error = `${channel}Error`;
    const options = {
      data: {
        platform: channel,
        name: _.trimStart(handle, '@'),
      },
    };

    this.setState({
      [loading]: true,
    });

    if (handle.length === 0) {
      return this.setState({
        [loading]: false,
        [count]: 0,
        [error]: false,
      });
    }

    return setTimeout(() => axios
      .post(process.env.REACT_APP_GET_INFLUENCER_DATA_URL, options)
      .then(async r => {
        const channelData = _.get(r, 'data.body.data', {});
        const updatedData = {
          [loading]: false,
          [count]: channelData.followerCount,
          [error]: false,
        };
        if (channel === 'instagram' && channelData.id) {
          updatedData.instagramId = channelData.id;
        }
        this.setState(updatedData);
      })
      .catch(() => {
        this.setState({ [loading]: false, [error]: true });
      }), 1000);
  }


  reset = () =>
    this.setState({
      editing: false,
      facebook: this.props.influencer.facebook,
      instagram: this.props.influencer.instagram,
      twitter: this.props.influencer.twitter,
      youtube: this.props.influencer.youtube,
      pinterest: this.props.influencer.pinterest,
      otherChannels: this.props.influencer.otherChannels,
      twitch: this.props.influencer.twitch,
      tiktok: this.props.influencer.tiktok,
      web: this.props.influencer.web,
      snapchat: this.props.influencer.snapchat,
      linkedin: this.props.influencer.linkedin,
    });

  handleChange = (e, v) => {
    const value = _.replace(_.get(v, 'value'), /\s/g, '');
    this.setState({ [v.name]: value });
    this.getChannelData(v.name, value);
  };

  findIcon = (count, error) => {
    if (this.state.editing) {
      if (error) {
        return 'close';
      }
      return count > 0 ? 'check' : 'search';
    }
    return <Icon name="external" basic circular style={externalIconStyle} />;
  };

  sanitizeLink = (platform, link) => {
    if (_.startsWith(link, 'http')) {
      return link;
    }
    switch (platform) {
    case 'facebook':
      return `https://facebook.com/${link}`;
    case 'twitter':
      return `https://twitter.com/${link}`;
    case 'youtube':
      return `https://youtube.com/channel/${link}`;
    case 'pinterest':
      return `https://pinterest.com/${link}`;
    case 'instagram':
      return `https://instagram.com/${link}`;
    case 'linkedin':
      return `https://www.linkedin.com/in/${link}`;
    case 'tiktok':
      return `https://www.tiktok.com/@${link}`;
    default:
      return null;
    }
  }

  render() {
    const {
      editing,
      facebook,
      facebookCount,
      facebookLoading,
      facebookError,
      instagram,
      instagramCount,
      instagramLoading,
      instagramError,
      instagramId,
      twitter,
      twitterCount,
      twitterLoading,
      twitterError,
      tiktok,
      tiktokCount,
      tiktokError,
      tiktokLoading,
      youtube,
      youtubeCount,
      youtubeLoading,
      youtubeError,
      youtubeChannelTitle,
      otherChannels,
      twitch,
      web,
      snapchat,
      linkedin,
      pinterest,
    } = this.state;
    const influencerID = this.props.influencer.id;
    const facebookInitial = this.props.influencer.facebook;
    const instagramInitial = this.props.influencer.instagram;
    const twitterInitial = this.props.influencer.twitter;
    const youtubeInitial = this.props.influencer.youtube;
    const status = this.props.influencer.status;
    const isClaimed = status === 'CLAIMED';

    return (
      <Segment padded>
        <h3>Social</h3>
        <Table basic="very">
          <Table.Body>
            <Table.Row>
              <Table.Cell collapsing>
                <img src="/icons/facebook.svg" alt="Facebook" readOnly={!editing} />
              </Table.Cell>
              <Table.Cell collapsing>
                <Tooltip content={<img src="/images/find-facebook-handle.png" alt="info" />} style="frame small">
                  <p className="nowrap">Facebook <img src="/icons/info.svg" alt="info" /></p>
                </Tooltip>
              </Table.Cell>
              <Table.Cell colSpan={3}>
                <NetworkHandleInput
                  network="facebook"
                  name="facebook"
                  value={facebook}
                  onChange={this.handleChange}
                  as={!editing && Link}
                  placeholder="Facebook"
                  to={this.sanitizeLink('facebook', facebook)}
                  target="_blank"
                  fluid
                  loading={facebookLoading}
                  error={facebookError}
                  count={facebookCount}
                  readOnly={!editing}
                />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>
                <img src="/icons/instagram.svg" alt="Instagram" />
              </Table.Cell>
              <Table.Cell collapsing>
                <Tooltip content={<img src="/images/find-instagram-handle.png" alt="info" />} style="frame small">
                  <p className="nowrap">Instagram <img src="/icons/info.svg" alt="info" /></p>
                </Tooltip>
              </Table.Cell>
              <Table.Cell colSpan={3}>
                <NetworkHandleInput
                  network="instagram"
                  name="instagram"
                  value={instagram}
                  onChange={this.handleChange}
                  as={!editing && Link}
                  placeholder="Instagram"
                  to={this.sanitizeLink('instagram', instagram)}
                  target="_blank"
                  fluid
                  loading={instagramLoading}
                  error={instagramError}
                  count={instagramCount}
                  readOnly={!editing}
                />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>
                <img src="/icons/twitter.svg" alt="Twitter" />
              </Table.Cell>
              <Table.Cell collapsing>
                <Tooltip content={<img src="/images/find-twitter-handle.png" alt="info" />} style="frame small">
                  <p className="nowrap">Twitter <img src="/icons/info.svg" alt="info" /></p>
                </Tooltip>
              </Table.Cell>
              <Table.Cell colSpan={3}>
                <NetworkHandleInput
                  network="twitter"
                  name="twitter"
                  value={twitter}
                  onChange={this.handleChange}
                  as={!editing && Link}
                  placeholder="Twitter"
                  to={this.sanitizeLink('twitter', twitter)}
                  target="_blank"
                  fluid
                  loading={twitterLoading}
                  error={twitterError}
                  count={twitterCount}
                  readOnly={!editing}
                />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>
                <img src="/icons/youtube.svg" alt="YouTube" />
              </Table.Cell>
              <Table.Cell collapsing>
                <Tooltip content={<img src="/images/find-youtube-handle.png" alt="info" />} style="frame small">
                  <p className="nowrap">Youtube <img src="/icons/info.svg" alt="info" /></p>
                </Tooltip>
              </Table.Cell>
              <Table.Cell colSpan={3}>
                <NetworkHandleInput
                  network="youtube"
                  name="youtube"
                  value={youtube}
                  onChange={this.handleChange}
                  as={!editing && Link}
                  placeholder="Youtube"
                  to={this.sanitizeLink('youtube', youtube)}
                  target="_blank"
                  fluid
                  loading={youtubeLoading}
                  error={youtubeError}
                  count={youtubeCount}
                  readOnly={!editing}
                />
                <br />
                {youtubeChannelTitle && <Label size="large" color="green" basic>{youtubeChannelTitle}</Label>}
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell collapsing>
                <Icon name="pinterest" color="red" />
              </Table.Cell>
              <Table.Cell collapsing>
                <p className="nowrap">Pinterest</p>
              </Table.Cell>
              <Table.Cell colSpan={3}>
                <Input
                  name="pinterest"
                  value={pinterest}
                  onChange={this.handleChange}
                  as={!editing && Link}
                  placeholder="Pinterest"
                  to={this.sanitizeLink('pinterest', pinterest)}
                  icon={this.findIcon(facebookCount, facebookError)}
                  target="_blank"
                  fluid
                  readOnly={!editing}
                />
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell collapsing>
                <Icon name="twitch" color="purple" />
              </Table.Cell>
              <Table.Cell collapsing>
                <p className="nowrap">Twitch</p>
              </Table.Cell>
              <Table.Cell colSpan={3}>
                <Input
                  name="twitch"
                  value={twitch}
                  onChange={this.handleChange}
                  placeholder="Twitch"
                  fluid
                  readOnly={!editing}
                />
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell collapsing>
                <TiktokIcon />
              </Table.Cell>
              <Table.Cell collapsing>
                <p className="nowrap">TikTok</p>
              </Table.Cell>
              <Table.Cell colSpan={3}>
                <NetworkHandleInput
                  network="tiktok"
                  name="tiktok"
                  value={tiktok}
                  onChange={this.handleChange}
                  as={!editing && Link}
                  placeholder="Tiktok"
                  to={this.sanitizeLink('tiktok', tiktok)}
                  target="_blank"
                  fluid
                  loading={tiktokLoading}
                  error={tiktokError}
                  count={tiktokCount}
                  readOnly={!editing}
                />
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell collapsing>
                <Icon name="snapchat ghost" color="yellow" />
              </Table.Cell>
              <Table.Cell collapsing>
                <p className="nowrap">Snapchat</p>
              </Table.Cell>
              <Table.Cell colSpan={3}>
                <Input
                  name="snapchat"
                  value={snapchat}
                  onChange={this.handleChange}
                  placeholder="Snapchat"
                  fluid
                  readOnly={!editing}
                />
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell collapsing>
                <Icon name="linkedin" color="blue" />
              </Table.Cell>
              <Table.Cell collapsing>
                <p className="nowrap">LinkedIn</p>
              </Table.Cell>
              <Table.Cell colSpan={3}>
                <NetworkHandleInput
                  network="linkedin"
                  name="linkedin"
                  error={false}
                  value={linkedin}
                  loading={false}
                  as={!editing && Link}
                  to={this.sanitizeLink('linkedin', linkedin)}
                  target="_blank"
                  readOnly={!editing}
                  onChange={this.handleChange}
                  fluid
                />
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell collapsing>
                <Icon name="world" color="blue" />
              </Table.Cell>
              <Table.Cell collapsing>
                <p className="nowrap">Website/blog</p>
              </Table.Cell>
              <Table.Cell colSpan={3}>
                <Input
                  name="web"
                  value={web}
                  onChange={this.handleChange}
                  placeholder="Website or blog"
                  fluid
                  readOnly={!editing}
                />
              </Table.Cell>
            </Table.Row>


            { otherChannels &&
                otherChannels.map(c => {
                  const channelName = c.name;
                  const channelHandle = c.handle;

                  return (
                    <Table.Row key={`${channelName}_${channelHandle}`}>
                      <Table.Cell collapsing>
                        <img src="/icons/transparent.svg" alt="no channel" />
                      </Table.Cell>
                      <Table.Cell>
                        {channelName}
                      </Table.Cell>
                      <Table.Cell colSpan={3}>
                        { _.startsWith(channelHandle, 'http')
                          ? <a href={channelHandle} target="_blank" rel="noopener noreferrer">
                            {channelHandle}
                          </a>
                          : channelHandle}
                      </Table.Cell>
                    </Table.Row>
                  );
                })}
            {editing
              ? <Table.Row>
                <Table.Cell colSpan={2}>
                  <div className="spacer small" />
                  <Button size="medium" basic fluid onClick={this.reset}>Cancel</Button>
                </Table.Cell>
                <Table.Cell colSpan={3}>
                  <div className="spacer small" />
                  <Button
                    size="medium"
                    fluid
                    color="pink"
                    onClick={() => {
                      updateProfileSocialDetails(
                        influencerID,
                        facebook,
                        facebookCount,
                        instagram,
                        instagramCount,
                        instagramId,
                        twitter,
                        twitterCount,
                        youtube,
                        youtubeCount,
                        twitch,
                        web,
                        snapchat,
                        pinterest,
                        linkedin,
                        tiktok,
                        tiktokCount,
                      );
                      this.setState({ editing: false });
                    }}
                    disabled={
                      (facebook !== facebookInitial ||
                          instagram !== instagramInitial ||
                          twitter !== twitterInitial ||
                          youtube !== youtubeInitial) &&
                          (facebookLoading ||
                            facebookError ||
                            instagramLoading ||
                            instagramError ||
                            twitterLoading ||
                            twitterError ||
                            youtubeLoading ||
                            youtubeError)
                    }
                  >
                      Save Changes
                  </Button>
                </Table.Cell>
              </Table.Row>
              : <Table.Row>
                <Table.Cell colSpan={3}>
                  <div className="spacer small" />
                  <EditButton
                    isClaimed={isClaimed}
                    content="Edit Social Details"
                    onClick={() => this.setState({ editing: true })}
                  />
                </Table.Cell>
              </Table.Row>}
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}

export default ProfileSocialDetails;



/** WEBPACK FOOTER **
 ** ./src/containers/influencer-profile/profile-social-details.js
 **/